<template>
    <div class="table-responsive">
        <form>
            <table class="table">
                <thead>
                    <tr class="table-light text-dark border-secondary">
                        <th class="fw-bold" style="width: 30%;">{{TR.name}}</th>
                        <th class="fw-bold">{{TR.value}}</th>
                    </tr>
                </thead>
                <tbody v-if="data.table_columns">
                    <template v-for="(item, index) in data.table_columns" :key="index">
                        <tr v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">
                            <td v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')" v-html="item.title"></td>

                            <td class="" v-if="G.userHavePermission(data.data.permission_method)">
                                <Image
                                    v-if="item.name == 'preview_image' && item.field_type == 'label'"
                                    :src="PO[item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="true"
                                />
                                <div v-else-if="item.field_type == 'image'" class="d-flex flex-sm-row1 flex-column text-nowrap align-items-start">
                                    <FileUpload
                                        v-model="PO[item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name)"
                                        accept="image/*"
                                        :multiple="item.fileMultiple || false"
                                        :maxFileSize="item.fileMaxSize"
                                        :fileLimit="item.fileLimit || false"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template #empty>
                                            <p>{{TR.drag_file}}</p>
                                        </template>
                                    </FileUpload>
                                    <span class="mx-2">{{TR.or}}</span>
                                    <InputText
                                        v-model="PO[item.name]"
                                        type="text"
                                        class=""
                                        @change="onImageChanged($event, item.name)"
                                        :placeholder="TR.link"
                                    />
                                </div>
                                <div v-else-if="item.field_type == 'file'">
                                    <FileUpload
                                        v-model="PO[item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name)"
                                        :accept="item.accept !== undefined ? item.accept : ''"
                                        :multiple="item.fileMultiple || false"
                                        :maxFileSize="item.fileMaxSize"
                                        :fileLimit="item.fileLimit || 1"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template #empty>
                                            <p>{{TR.drag_file}}</p>
                                        </template>
                                    </FileUpload>
                                    <span class="mx-2">{{TR.or}}</span>
                                    <InputText
                                        v-model="PO[item.name]"
                                        type="text"
                                        class=""
                                        @change="onImageChanged($event, item.name)"
                                        :placeholder="TR.link"
                                    />
                                </div>
                                <InputText
                                    v-else-if="item.field_type == 'text'"
                                    v-model="PO[item.name]"
                                    type="text"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === '') ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputText v-else-if="item.field_type == 'password'" v-model="PO[item.name]" type="password" :class="item.required && (PO[item.name] === undefined || PO[item.name] === '') ? 'required' : ''"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputNumber v-else-if="item.field_type == 'numeric'" v-model="PO[item.name]" :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputMask v-else-if="item.field_type == 'mask'" v-model="PO[item.name]" :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')" :[item.attr]="item.attrValue" />
                                <InputNumber v-else-if="item.field_type == 'currency'"
                                    v-model="PO[item.name]"
                                    mode="currency"
                                    :currency="store.getCurrency()"
                                    :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputNumber v-else-if="item.field_type == 'integer'" v-model="PO[item.name]" integeronly :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :min="item.min !== undefined ? item.min : 0"
                                    mode="decimal"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <!-- <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO[item.name]" defaultColor="{'r':128,'g':22,'b':22}" style="background-color: var(--bs-primary-rgb);" format="rgb" :class="item.required && (PO[item.name] === undefined || PO[item.name] === null) ? 'required' : ''" :placeholder="item.placeholder || item.title || ''" -->
                                <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO[item.name]" defaultColor="03446c" format="rgb" :placeholder="item.placeholder || item.title || ''" />

                                <div v-else-if="item.field_type == 'switch'" class="form-check form-switch" :class="item.class">
                                    <input
                                        v-model="PO[item.name]"
                                        :id="`${item.name}_switch`"
                                        class="form-check-input cursor-pointer"
                                        :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                        @[item.event]="item.callback !== undefined ? item.callback($event, item, PO) : null"
                                        type="checkbox"
                                        role="switch"
                                        :placeholder="item.placeholder || item.title || ''"
                                    />
                                    <label class="form-check-label" :for="`${item.name}_switch`"></label>
                                </div>

                                <Textarea v-else-if="item.field_type == 'textarea'"
                                    v-model="PO[item.name]"
                                    :autoResize="false"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                    :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    class="form-control"
                                />
                                <Calendar v-else-if="item.field_type == 'date'"
                                    v-model="PO[item.name]"
                                    :dateFormat="item.filter_format"
                                    :maxDate="item.maxDate || null"
                                    :minDate="item.minDate || null"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :showButtonBar="true"
                                    :hideOnDateTimeSelect="true"
                                    :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                />
                                <Calendar v-else-if="item.field_type == 'time'"
                                    v-model="PO[item.name]"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :timeOnly="true"
                                    hourFormat="24"
                                    :hideOnDateTimeSelect="true"
                                    :placeholder="item.placeholder || item.title || 'hh:mm:ss'"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                />
                                <Dropdown v-else-if="item.field_type == 'selectbox'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.selectbox_items"
                                    optionValue="label"
                                    optionLabel="label"
                                    :editable="true"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :class="item.class + (item.required && (PO[item.name] === undefined || PO[item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null; PO[item.name] = selectedItem[item.name]"
                                    @input="(item.onInput !== undefined && typeof item.onInput == 'function' ? item.onInput($event, item) : null); PO[item.name] = selectedItem[item.name]"
                                />
                                <Dropdown v-else-if="item.field_type == 'dropdown'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="item.placeholder || TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO[item.name] === undefined || PO[item.name] === null || PO[item.name] == 0) ? ' required' : '')"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null; PO[item.name] = selectedItem[item.name]"
                                    @input="(item.onInput !== undefined && typeof item.onInput == 'function' ? item.onInput($event, item) : null); PO[item.name] = selectedItem[item.name]"
                                >
                                    <template #value="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                            v-if="slotProps.value"
                                            v-html="item.dropdown_items.filter((e) => e.value == slotProps.value)[0]?.label"
                                        ></div>
                                        <span v-else>{{slotProps.placeholder}}</span>
                                    </template>
                                    <template #option="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                            v-html="slotProps.option.label"
                                        ></div>
                                    </template>
                                </Dropdown>

                                <!-- <Teleport v-else-if="item.field_type == 'text_content'" to="body">
                                    <SecondModal :mainref="mainref" :show="showModal" :title="editor.title" :width="70" :toolbar="editor" :data="editor.data" @close="onModalClose" />
                                </Teleport> -->

                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></span>

                                <!-- <template v-for="(btn, bindex) in item.buttons" :key="bindex">
                                        <button
                                            :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                            :title="btn.title !== undefined ? btn.title : ''"
                                            @click="$event.preventDefault(); showModal = true;"
                                        >
                                            <i :class="`me-1 ${btn.icon}`"></i>
                                            {{btn.label}}
                                        </button>{{btn}}
                                        <Teleport to="body">
                                            <SecondModal :show="showModal" :mainref="mainref" :data="btn" @close="showModal = false">
                                                <template #header>
                                                    custom header
                                                </template>
                                            </SecondModal>
                                        </Teleport> -->
                                    <!-- <button
                                        :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                        :title="btn.title !== undefined ? btn.title : ''"
                                        @click="btn.command(data, $event)"
                                    >
                                        <i :class="`me-1 ${btn.icon}`"></i>
                                        {{btn.label}}
                                    </button> -->
                                <!-- </template> -->




                            <!-- <div
                                v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)"
                                :class="item.class"
                            > -->
                            <!-- <div v-if="(item.private !== undefined && typeof item.private === 'function' ? item.private(data) === false ? true : false : (item.private === undefined || item.private === false ? true : false)) && item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)" :class="item.class"> -->

                                <template v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)">
                                    <template v-for="(el, elind) in item.buttons" :key="elind">
                                        <!-- <div> -->
                                            <div v-if="el.type == 'switch'" :class="el.class" class="form-check form-switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                                                <input
                                                    class="form-check-input"
                                                    @[el.event]="el.callback($event, item.data, PO)"
                                                    type="checkbox"
                                                    role="switch"
                                                    :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                                />
                                            </div>
                                        <!-- </div> -->
                                        <input
                                            v-else-if="el.type == 'checkbox'"
                                            class="form-check-input"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="checkbox"
                                            role="switch"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        />
                                        <input
                                            v-else-if="el.type == 'text'"
                                            class="form-control"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="text"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        />
                                        <button
                                            v-else-if="el.type == 'button' && (item.btn_visible && typeof item.btn_visible === 'function' ? item.btn_visible(item.data) : item.btn_visible !== undefined ? item.btn_visible : true)"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        >
                                            <i v-if="el.icon" :class="el.icon"></i>
                                            <span>{{el.text}}</span>
                                        </button>
                                    </template>
                                </template>
                            <!-- </div> -->
                            <!-- <div v-else="" v-html="(item.value && typeof item.value === 'function' ? item.value(data.data) : item.value !== undefined ? item.value : true)"></div> -->


                            </td>

                            <td v-else-if="item.field_type != 'image' && item.field_type != 'file'">
                                <Image
                                    v-if="item.name == 'preview_image' && item.field_type == 'label'"
                                    :src="PO[item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="false"
                                />
                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></span>
                            </td>
                            <!-- <td v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></td> -->

                        </tr>
                    </template>

                </tbody>
            </table>
        </form>
    </div>

</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { G } from "@/_common";

    import { useModelWrapper } from "@/utils/modelWrapper";

    import Dropdown from "primevue/dropdown";
    import InputText from "primevue/inputtext";
    import Textarea from "primevue/textarea";
    import InputNumber from "primevue/inputnumber";
    import InputMask from "primevue/inputmask";
    import Calendar from "primevue/calendar";
    import FileUpload from "primevue/fileupload";
    import Image from "primevue/image";
    import ColorPicker from 'primevue/colorpicker';

    export default {
        name: 'DynamicTable2',
        props: {
            data: {
                type: Object,
                default(){
                    return null;
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                }
            },
        },
        components: {
            // SecondModal,
            Dropdown,
            InputText,
            Textarea,
            InputNumber,
            InputMask,
            Calendar,
            FileUpload,
            Image,
            ColorPicker,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const PO = useModelWrapper(props, emit, "mainref");
            const selectedItem = ref({});

            const showModal = ref(false);
            // const editor = ref({data: {editorData: ''}});

            const onFileChanged = (e, field_name) => {
                // const target = $event.target as HTMLInputElement;
                // file = e.target.files[0];
                // if (e.target && e.target.files) {
                if (e.files) {
                    let a = false;
                    if( props.data.table_columns ){
                        props.data.table_columns.forEach((item) => {
                            if(item.name == field_name && item.fileMultiple){
                                a = true;
                                PO.value[field_name] = e.files;
                            }
                        });
                    }
                    if(!a){
                        PO.value[field_name] = e.files[0];
                    }
                    PO.value["preview_image"] = e.files[0].objectURL;
                    // props.data['preview_image'] = e.files[0].objectURL;
                }
            };

            const onImageChanged = (event) => {
                PO.value["preview_image"] = event.target.value;
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
                // props.data.table_columns.forEach((item) => {
                    // if( item.name == 'preview_image' && typeof item.field_type !== undefined && item.field_type == 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    //     // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( typeof item.field_type !== undefined && item.field_type != 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( item.dropdown_item_selected !== undefined )
                    //     selectedItem.value[item.name] = item.dropdown_item_selected;
                // });
            });

            onMounted(() => {
                if( props.data.table_columns ){
                    props.data.table_columns.forEach((item) => {
                        if (
                            item.name == "preview_image" &&
                            typeof item.field_type !== undefined &&
                            item.field_type == "label"
                        ) {
                            PO.value[item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data)
                                    : props.data.data[item.value];
                            // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                        }
                        if (
                            typeof item.field_type !== undefined &&
                            item.field_type != "label"
                        ) {
                            PO.value[item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data)
                                    : props.data.data[item.value];
                        }
                        if (item.dropdown_item_selected !== undefined){
                            selectedItem.value[item.name] = item.dropdown_item_selected;
                            PO.value[item.name] = item.dropdown_item_selected;
                        }
                        if (item.selectbox_item_selected !== undefined){
                            selectedItem.value[item.name] = item.selectbox_item_selected;
                            PO.value[item.name] = item.selectbox_item_selected;
                        }
                    });
                }
            });

            return {
                G,
                TR,
                store,
                PO,
                selectedItem,
                onFileChanged,
                onImageChanged,
                showModal,
                // editor,
            };
        },
    };
</script>


<style lang="scss" scoped>
    .modal-backdrop{
        z-index: 9;
    }
    .table {
        width: 100%;
        margin-bottom: 1rem;
        // color: #7b809a;
        vertical-align: top;
        border-color: #f0f2f5;
    }
    .table thead th {
        // padding: .75rem 1.5rem;
        letter-spacing: 0;
        border-bottom: 1px solid #f0f2f5;
        border-bottom-color: rgb(240, 242, 245);
        text-transform: uppercase !important;
        color: var(--bs-secondary);
    }
    .table > :not(:first-child) {
        border-top: 1px solid currentColor;
    }
    .table.align-items-center td,
    .table.align-items-center th {
        vertical-align: middle;
    }
    .p-dropdown {
        width: 12rem;
    }
    .required{
        border: 1px solid #ff0000;
        border-radius: 5px;
    }
    .p-image-toolbar{
        z-index: 9999;
        background: rgba(190, 190, 190, 0.5);
    }
    .p-image-preview{
        background-color: #fff;
        height: 90%;
    }
</style>

